import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService, GlobalMessageService, ISession } from '@simac/ui';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject, take } from 'rxjs';
import { IIncident } from '../models/incident';

@Injectable({
  providedIn: 'root',
})
export class SspGlobalMessgeService {
  private readonly permissionsService = inject(NgxPermissionsService);
  private readonly apiService = inject(ApiService);
  private readonly globalMessageService = inject(GlobalMessageService);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);

  majorIncidenten: IIncident[] = [];
  majorSelected = new Subject<void>();

  getMajorIncident(): void {
    if (this.permissionsService.getPermission('Module.ServiceAndSupport.Incident.View') !== undefined) {
      this.apiService
        .get<IIncident[]>(`api/serviceandsupport/incident/major/open`)
        .pipe(take(1))
        .subscribe((result) => {
          this.majorIncidenten = result;
          this.createGlobalMessages();
        });
    }
  }

  checkUserHasFullName(session: ISession): void {
    if (!session.custom?.SspRequestInfo?.userHasFullName) {
      this.globalMessageService.addMessage({
        key: 'ssp-user-fullname',
        closable: true,
        message: this.translate.instant('SSP.FULLNAME-INFO'),
        severity: 'info',
        command: () => {
          this.router.navigate(['profile']);
        },
      });
    }
  }

  private createGlobalMessages(): void {
    this.majorIncidenten.forEach((incident: IIncident) => {
      if (!this.globalMessageService.globalMessages.find((o) => o.key === incident.id)) {
        this.globalMessageService.addMessage({
          key: incident.id,
          closable: true,
          message: incident.briefDescription,
          severity: 'warning',
          command: () => {
            this.majorSelected.next();
            this.router.navigate(['serviceandsupport', 'incident', incident.id], { queryParams: { major: true } });
          },
        });
      }
    });
  }
}
